import types from "./types";

const fetchMagnetReportStart = () => {
  return {
    type: types.FETCH_MAGNET_REPORT_START,
  };
};

const fetchMagnetReport = magnetReport => {
  return {
    type: types.FETCH_MAGNET_REPORT,
    payload: magnetReport,
  };
};

const fetchMagnetReportError = err => {
  return {
    type: types.FETCH_MAGNET_REPORT_ERROR,
    payload: err,
  };
};

export default {
  fetchMagnetReport,
  fetchMagnetReportStart,
  fetchMagnetReportError,
};



// WEBPACK FOOTER //
// ./src/redux/magnetReport/actions.js